
/* =============================================
   MOONGODDESS COUTURE - Premium Interactions
   ============================================= */

(function() {
  'use strict';

  // --- 1. SCROLL REVEAL ANIMATIONS ---
  const revealElements = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mg-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    // Observe all major sections and elements
    document.querySelectorAll(
      '.cro-circular-item, .cro-usp-item, .cro-testimonial-card, ' +
      '.cro-occasion-card, .cro-insta-item, .cro-section-header, ' +
      '.collection-list__item, .card--card, .card--standard, ' +
      'section > .page-width > h2, .rich-text__blocks'
    ).forEach((el, i) => {
      el.classList.add('mg-reveal');
      el.style.transitionDelay = (i % 5) * 0.1 + 's';
      observer.observe(el);
    });
  };

  // --- 2. FLOATING WHATSAPP BUTTON ---
  const createWhatsApp = () => {
    const btn = document.createElement('a');
    btn.href = 'https://wa.me/919995642099?text=Hi! I am interested in your products';
    btn.target = '_blank';
    btn.className = 'mg-whatsapp-float';
    btn.setAttribute('aria-label', 'Chat on WhatsApp');
    btn.innerHTML = '<svg viewBox="0 0 32 32" width="28" height="28" fill="white"><path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.9 15.9 0 0016.004 32C24.826 32 32 24.826 32 16.004S24.826 0 16.004 0zm9.302 22.602c-.396 1.11-1.946 2.034-3.19 2.304-.846.182-1.952.326-5.674-1.22-4.762-1.978-7.826-6.816-8.064-7.132-.23-.316-1.906-2.54-1.906-4.844s1.206-3.436 1.636-3.906c.43-.47.938-.588 1.25-.588.312 0 .624.002.898.016.288.014.674-.11 1.054.804.396.95 1.35 3.292 1.468 3.53.118.24.198.518.04.834-.158.316-.238.514-.474.79-.238.278-.5.62-.714.832-.238.238-.486.496-.208.97.276.474 1.228 2.026 2.638 3.282 1.81 1.614 3.338 2.114 3.812 2.352.474.238.752.198 1.028-.118.278-.316 1.186-1.382 1.504-1.856.316-.474.634-.396 1.068-.238.434.158 2.77 1.306 3.244 1.544.474.238.79.356.908.554.118.198.118 1.148-.278 2.258z"/></svg>';
    document.body.appendChild(btn);
  };

  // --- 3. BACK TO TOP BUTTON ---
  const createBackToTop = () => {
    const btn = document.createElement('button');
    btn.className = 'mg-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 16V4M10 4L4 10M10 4L16 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    document.body.appendChild(btn);

    window.addEventListener('scroll', () => {
      btn.classList.toggle('mg-visible', window.scrollY > 500);
    });
  };

  // // --- 4. MARQUEE ANNOUNCEMENT BAR ---
  // const enhanceAnnouncement = () => {
  //   const bar = document.querySelector('.announcement-bar__message');
  //   if (!bar) return;
  //   const original = bar.textContent.trim();
  //   const messages = [original, '✨ New Arrivals Every Week', '🎁 Use Code MOON10 for 10% Off', '👗 Stitched to Your Measurements'];
  //   let idx = 0;
    
  //   setInterval(() => {
  //     bar.style.opacity = '0';
  //     bar.style.transform = 'translateY(-10px)';
  //     setTimeout(() => {
  //       idx = (idx + 1) % messages.length;
  //       bar.textContent = messages[idx];
  //       bar.style.opacity = '1';
  //       bar.style.transform = 'translateY(0)';
  //     }, 400);
  //   }, 4000);
    
  //   bar.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
  // };

  // --- 5. NEWSLETTER POPUP ---
  const createNewsletterPopup = () => {
    if (sessionStorage.getItem('mg-popup-shown')) return;
    
    const overlay = document.createElement('div');
    overlay.className = 'mg-popup-overlay';
    overlay.innerHTML = `
      <div class="mg-popup">
        <button class="mg-popup-close" aria-label="Close">&times;</button>
        <div class="mg-popup-content">
          <div class="mg-popup-left">
            <div class="mg-popup-icon">✦</div>
          </div>
          <div class="mg-popup-right">
            <h3 class="mg-popup-title">Get 10% Off Your First Order</h3>
            <p class="mg-popup-text">Join the Moongoddess family and receive exclusive offers, new collection alerts & styling tips.</p>
            <form class="mg-popup-form" action="/contact#contact_form" method="post">
              <input type="hidden" name="form_type" value="customer">
              <input type="hidden" name="contact[tags]" value="newsletter">
              <input type="email" name="contact[email]" placeholder="Enter your email" class="mg-popup-input" required>
              <button type="submit" class="mg-popup-btn">CLAIM MY 10% OFF</button>
            </form>
            <p class="mg-popup-disclaimer">No spam, unsubscribe anytime.</p>
          </div>
        </div>
      </div>
    `;
    
    const close = () => {
      overlay.classList.add('mg-popup-closing');
      sessionStorage.setItem('mg-popup-shown', '1');
      setTimeout(() => overlay.remove(), 400);
    };
    
    overlay.querySelector('.mg-popup-close').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    
    setTimeout(() => {
      document.body.appendChild(overlay);
      requestAnimationFrame(() => overlay.classList.add('mg-popup-active'));
    }, 5000);
  };

  // --- 6. PRODUCT CARD ENHANCEMENTS ---
  const enhanceProductCards = () => {
    document.querySelectorAll('.card-wrapper').forEach(card => {
      // Add wishlist heart
      if (!card.querySelector('.mg-wishlist')) {
        const heart = document.createElement('button');
        heart.className = 'mg-wishlist';
        heart.setAttribute('aria-label', 'Add to wishlist');
        heart.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
        heart.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          heart.classList.toggle('mg-wishlisted');
        });
        const imgWrap = card.querySelector('.card__inner, .media');
        if (imgWrap) { imgWrap.style.position = 'relative'; imgWrap.appendChild(heart); }
      }

      // Add quick view button
      const link = card.querySelector('a[href*="/products/"]');
      if (link && !card.querySelector('.mg-quick-view')) {
        const qv = document.createElement('button');
        qv.className = 'mg-quick-view';
        qv.textContent = 'QUICK VIEW';
        qv.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = link.href;
        });
        const imgWrap = card.querySelector('.card__inner, .media');
        if (imgWrap) imgWrap.appendChild(qv);
      }
    });
  };

  // --- 7. SMOOTH HEADER SHRINK ON SCROLL ---
  const headerShrink = () => {
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      header.classList.toggle('mg-header-scrolled', window.scrollY > 100);
    });
  };

  // --- 8. IMAGE HOVER ZOOM EFFECT ---
  const imageHoverZoom = () => {
    document.querySelectorAll('.card__media img, .collection-list__item img').forEach(img => {
      img.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      img.parentElement.style.overflow = 'hidden';
      img.addEventListener('mouseenter', () => img.style.transform = 'scale(1.08)');
      img.addEventListener('mouseleave', () => img.style.transform = 'scale(1)');
    });
  };

  // --- 9. PARALLAX HERO ---
  const parallaxHero = () => {
    const slideshow = document.querySelector('.slideshow');
    if (!slideshow) return;
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        slideshow.style.transform = 'translateY(' + (scrolled * 0.1) + 'px)';
      }
    });
  };

  // --- 10. CURSOR TRAIL EFFECT (subtle gold dots) ---
  const cursorTrail = () => {
    if (window.innerWidth < 768) return;
    const canvas = document.createElement('canvas');
    canvas.className = 'mg-cursor-canvas';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    let dots = [];
    
    window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
    
    document.addEventListener('mousemove', (e) => {
      dots.push({ x: e.clientX, y: e.clientY, life: 1 });
      if (dots.length > 20) dots.shift();
    });
    
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      dots.forEach((dot, i) => {
        dot.life -= 0.03;
        if (dot.life <= 0) { dots.splice(i, 1); return; }
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, dot.life * 3, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(139, 105, 20, ' + (dot.life * 0.3) + ')';
        ctx.fill();
      });
      requestAnimationFrame(animate);
    };
    animate();
  };

  // --- 11. COUNTDOWN TIMER (inject into page) ---
  const createCountdown = () => {
    const target = document.querySelector('.cro-occasions');
    if (!target) return;
    
    const countdown = document.createElement('div');
    countdown.className = 'mg-countdown-banner';
    countdown.innerHTML = `
      <div class="page-width">
        <div class="mg-countdown-inner">
          <div class="mg-countdown-text">
            <span class="mg-countdown-label">LIMITED TIME OFFER</span>
            <h3 class="mg-countdown-heading">Wedding Season Sale - Up to 30% Off</h3>
          </div>
          <div class="mg-countdown-timer">
            <div class="mg-countdown-unit"><span class="mg-cd-num" id="mg-cd-days">00</span><span class="mg-cd-label">Days</span></div>
            <div class="mg-countdown-sep">:</div>
            <div class="mg-countdown-unit"><span class="mg-cd-num" id="mg-cd-hours">00</span><span class="mg-cd-label">Hours</span></div>
            <div class="mg-countdown-sep">:</div>
            <div class="mg-countdown-unit"><span class="mg-cd-num" id="mg-cd-mins">00</span><span class="mg-cd-label">Mins</span></div>
            <div class="mg-countdown-sep">:</div>
            <div class="mg-countdown-unit"><span class="mg-cd-num" id="mg-cd-secs">00</span><span class="mg-cd-label">Secs</span></div>
          </div>
          <a href="/collections/all" class="mg-countdown-cta">SHOP THE SALE</a>
        </div>
      </div>
    `;
    target.parentNode.insertBefore(countdown, target);
    
    // Set end date 7 days from now
    const end = new Date();
    end.setDate(end.getDate() + 7);
    
    const updateTimer = () => {
      const now = new Date();
      const diff = end - now;
      if (diff <= 0) return;
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      document.getElementById('mg-cd-days').textContent = String(d).padStart(2, '0');
      document.getElementById('mg-cd-hours').textContent = String(h).padStart(2, '0');
      document.getElementById('mg-cd-mins').textContent = String(m).padStart(2, '0');
      document.getElementById('mg-cd-secs').textContent = String(s).padStart(2, '0');
    };
    updateTimer();
    setInterval(updateTimer, 1000);
  };

  // --- 12. RECENTLY VIEWED (uses sessionStorage) ---
  const recentlyViewed = () => {
    // Only track on product pages
    if (window.location.pathname.includes('/products/')) {
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (handle) {
        let viewed = JSON.parse(sessionStorage.getItem('mg-recent') || '[]');
        viewed = viewed.filter(h => h !== handle);
        viewed.unshift(handle);
        viewed = viewed.slice(0, 10);
        sessionStorage.setItem('mg-recent', JSON.stringify(viewed));
      }
    }
  };

  // --- 13. SMOOTH SCROLL FOR ANCHOR LINKS ---
  const smoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', (e) => {
        const target = document.querySelector(a.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  };

  // --- 14. LOADING ANIMATION ---
  const pageLoad = () => {
    const loader = document.createElement('div');
    loader.className = 'mg-page-loader';
    loader.innerHTML = '<div class="mg-loader-spinner"></div>';
    document.body.appendChild(loader);
    
    window.addEventListener('load', () => {
      setTimeout(() => {
        loader.classList.add('mg-loader-done');
        setTimeout(() => loader.remove(), 600);
      }, 300);
    });
  };

  // --- INITIALIZE EVERYTHING ---
  // Page loader first
  pageLoad();
  
  // Rest on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    revealElements();
    createWhatsApp();
    createBackToTop();
    enhanceAnnouncement();
    createNewsletterPopup();
    enhanceProductCards();
    headerShrink();
    imageHoverZoom();
    parallaxHero();
    createCountdown();
    recentlyViewed();
    smoothScroll();
    // Cursor trail - uncomment if wanted (can be resource intensive)
    // cursorTrail();
  }

})();
